// Module
var code = "<div :class=\"['infoBox', { '-small': isSmall, '-smallest': isSmallest }]\"> <cSvg class=\"infoBox_image\" :height=\"isSmallest ? 16 : 24\" :href=\"svg\" :width=\"isSmallest ? 16 : 24\"/> <div class=\"infoBox_content\"> <span class=\"infoBox_message t-infoBox_text\" v-html=\"message\"/> <slot/> </div> </div> ";
// Exports
export default code;